import React, { useState, useEffect, useRef, Fragment } from 'react';
import ReactDOM from 'react-dom';
import Vimeo from '@u-wave/react-vimeo';
import axios from 'axios';

export default function SingleVideo(props) {
    const MAX_PREVIEW_SECONDS = 60;
    const URL_LAST_SEEN_UPDATE_SERVICE = "/capacitacion/set-last-seen-content";

    const [videoObj, setVideoObj] = useState(null);
    const [stillPlaying, setStillPlaying] = useState(true)

    //Función para checkear que esté dentro del tiempo del preview
    const checkPreviewTime = () => {
        if (stillPlaying && videoObj && props.prvw) {
            videoObj.getCurrentTime().then(function (seconds) {
                if (seconds > MAX_PREVIEW_SECONDS) {
                    videoObj.pause()
                    setStillPlaying(false)
                    $('#preview-login-modal').modal();
                }
            });
        }
    }

    //Custom Hook para usar los state dentro de un setInteval
    // https://overreacted.io/making-setinterval-declarative-with-react-hooks/
    function useInterval(callback, delay) {
        const savedCallback = useRef();

        useEffect(() => {
            savedCallback.current = callback;
        });

        useEffect(() => {
            function tick() {
                savedCallback.current();
            }

            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }, [delay]);
    }

    const handleReady = (video_player) => {
        setVideoObj(video_player)
    }

    //Requerido para iniciar el video en mobile donde el autoplay no funciona
    const startVideo = (e) => {
        e.preventDefault()
        videoObj.play().then(function () {
            console.log('manual-play')
        })
        e.target.remove()
    }

    const handlePlay = () => {
        //Sólo si está loggeado, hago last-seen
        //Esto sólo se debería cumplir cuando es videoinforme y user está loggeado
        if (props.content_id != '') {
            //Envío el post para last-seen
            axios.post(URL_LAST_SEEN_UPDATE_SERVICE, {
                'content_id': props.content_id
            }).then(function (response) {
                console.log('last-seen-triggered:', response);
            }).catch(function (error) {
                console.log('error', JSON.parse(error));
            });
        }
    }

    //El chequeo eterno para asegurar que no vuelva a arrancar
    useInterval(() => {
        checkPreviewTime()
    }, 2000)

    const quickStyles = {
        outerDiv: {
            position: "relative",
        },
        innerDiv: {
            position: "absolute",
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
        },
        anchor: {
            fontSize: '68px',
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            borderRadius: '50%'
        }
    }


    return (
        stillPlaying ?
            <Fragment>

                <div style={quickStyles.outerDiv}>
                    <Vimeo id="player-modulo" className="vimeo-container" video={props.videoId}
                        controls={!props.prvw} onReady={handleReady} onPlay={handlePlay} />
                    {
                        props.prvw
                            ?
                            <a className="align-items-center d-flex justify-content-around text-decoration-none" style={quickStyles.innerDiv} href="#" onClick={(e) => startVideo(e)}>
                                <i style={quickStyles.anchor} className="far fa-play-circle naranja"></i>
                            </a>
                            : ''

                    }

                </div>


            </Fragment>
            :
            <div className="img-preview">
                <img src={props.prvimg} alt="Suscribite" className='w-100' />
            </div>
    )
}

const domContainer = document.querySelector('#single-controled-video');
ReactDOM.render(<SingleVideo
    videoId={domContainer.getAttribute('data-video-id')}
    prvw={domContainer.getAttribute('data-video-prvw')}
    prvimg={domContainer.getAttribute('data-video-img')}
    content_id={domContainer.getAttribute('data-content-id')}
/>, domContainer);
